module.exports = __webpack_public_path__ + "static/yah-e985ac1e26581132b7c48c71f30067f6.jpg";